module.exports = __webpack_public_path__ + "static/salecycle-6a5d679a29c699f2d07d57767fd5793d.svg";